import type { AppAction } from "@/types";

export const agreementLineItemDocumentUploaded: AppAction<{
    emit: (eventName: string) => void;
}> = async (args) => {
    args.emit("document-uploaded");
    return true;
};
